// extracted by mini-css-extract-plugin
export default {"tileSelector":"styles_tileSelector__Fxufr","active":"styles_active__bCfaq"};